import React, { useEffect, useState } from "react";
import { useAuth } from "../../../AuthenticationStore";
import logo from "../../../logo.svg";
import { proccessError } from "../../../components/utils/utils";
import { Modal, Form } from "semantic-ui-react";
import { useForm } from "react-hook-form";

import "../../../styles/Welcome.scss";

export const Welcome = () => {
  const { isNewUser, logout, platformUserService } = useAuth();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const { handleSubmit, register, errors } = useForm();

  useEffect(() => {
    if (isNewUser)
      if (!isNewUser.invitation) {
        setError(
          "El usuario no fue definido. sera redireccionado al login en breve."
        );
        setTimeout(() => {
          logout();
        }, 20000);
      }
  }, [isNewUser, logout]);

  const requestInformation = async () => setShow(true);

  const dismissInvitation = async () => {
    setLoading(true);
    const result = await platformUserService.dismissInvitation(
      isNewUser.invitation.invitationId
    );

    const errorsArray = proccessError(result);
    setLoading(false);

    if (errorsArray.length > 0) {
      setError(errorsArray[0]);
      return;
    }

    // redirect to home
    logout();
  };

  const reload = () => {
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  };

  const handleClose = () => setShow(false);

  const onSubmit = async values => {
    handleClose();
    setLoading(true);

    const result = await platformUserService.createPlatformUser(
      isNewUser.invitation.invitationId,
      values.userName,
      values.mobile
    );

    const errorsArray = proccessError(result);
    setLoading(false);

    if (errorsArray.length > 0) {
      setError(errorsArray[0]);
      return;
    }

    // ok
    reload();
  };

  return (
    <div className="container">
      <Modal open={show} onClose={handleClose} closeIcon>
        <Modal.Header>Informacion requerida</Modal.Header>
        <Modal.Content>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group widths="equal">
              <Form.Input
                fluid
                error={!!errors.userName}
                label="Nombre"
                placeholder="Nombre"
              >
                <input
                  name="userName"
                  ref={register({
                    required: "Required"
                  })}
                />
              </Form.Input>
              <Form.Input
                fluid
                error={!!errors.mobile}
                label="Telefono"
                placeholder="Telefono"
              >
                <input
                  name="mobile"
                  ref={register({
                    required: "Required"
                  })}
                />
              </Form.Input>
            </Form.Group>
            <button className="btn btn-primary btn-icon-text" type="submit">
              Completar registro
            </button>
          </Form>
        </Modal.Content>
      </Modal>
      <div className="row">
        <div className="col-sm">
          <img src={logo} alt="logo" className="rounded mx-auto d-block"></img>
        </div>
      </div>
      <div className="row">
        {error ? (
          <>
            <div className="col">
              <div
                className="col-sm alert alert-danger text-center"
                role="alert"
              >
                {error}
                <br></br>
                <br></br>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={reload}
                >
                  Recargar
                </button>
              </div>
            </div>
          </>
        ) : loading ? (
          <div className="col-sm text-center">
            <div className="ui active centered inline loader loading"></div>
          </div>
        ) : (
          <div className="col-sm text-center">
            <button
              type="button"
              className="btn btn-primary"
              onClick={requestInformation}
            >
              Aceptar invitacion
            </button>
            &nbsp; &nbsp;
            <button
              type="button"
              className="btn btn-danger"
              onClick={dismissInvitation}
            >
              Declinar invitacion
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
